// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhl_a bia_ea bia_a","LoadingSwitch__init":"bhl_b bia_a bia_w bia_j bia_ul bia_um bia_fm"};